import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class UssdStore extends EventDrivenStore {
  constructor() {
    const initialState = {
      simsList: {
        isLoading: false,
        data: []
      }
    };
    super('ussd', initialState);
  }

  async setupEvents() {
    this.on(constants.EVENTS.USSD.REQUEST_SIMS_LIST, () => {
      this.state.simsList.isLoading = true;
    });
    this.on(constants.EVENTS.USSD.SIMS_LIST_READY, ({ simList }) => {
      this.state.simsList.isLoading = false;
      this.state.simsList.data = simList;
    });
  }
}

export default UssdStore;
